import { jsx as _jsx } from "react/jsx-runtime";
export default function TextButton({ onClick, text }) {
    return (_jsx("button", { type: "button", className: "cursor-pointer rounded text-left text-sm underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary lg:text-[17px]", onClick: onClick, children: text }));
}
